<template>
<div id="parent-dashboard">
	<panel-basic :title="$t( 'MAIN_CONTENT.ParentHomePage.myStudents' )"
							 id="myStudents"
							 :collapsable="false">
		<div class="row">
			<!-- Student Select information -->
			<div v-if="!!selectedStudent" class="col-lg-5 col-md-7 student-information-wrap">
				<div class="inline-block">
					<div class="row">
						<div class="col-md-5 col-sm-6 student-pic">
							<img :src="selectedStudent.PHOTO_URL"
									 :alt="selectedStudent.NAME"
									 class="img-fluid"
									 style="cursor:pointer;"
									 @click="setSelectedStudent">
						</div>
						<div class="col-md-7 col-sm-6 student-info">
							<h2>{{ `${selectedStudent.FIRST_NAME} ${selectedStudent.LAST_NAME}` }}</h2>
							<p>
								<label>{{ $t('MAIN_CONTENT.ParentHomePage.homePhoneNumberTitleCaseWithColon') }}</label> <br>
								{{ selectedStudent.PHONE_NO | phone }} <br>
								<label>{{ $t('MAIN_CONTENT.ParentHomePage.emailWithColon') }}</label> <br>
								{{ selectedStudent.EMAIL_ADDRESS }}
							</p>
							<a @click="changeStudentData" class="pointer">
								<font-awesome-icon aria-hidden="true" icon="file-signature"></font-awesome-icon>
								<span class=""> {{ $t('MAIN_CONTENT.ChangeStudentData.sideMenuChangeStudentDataLink') }} </span> <br>
							</a>
							<div>
								<button type="submit" class="btn btn-primary btn-backpack" @click="setSelectedStudent">
									{{ $t('MAIN_CONTENT.ParentHomePage.goToMyBackpack', { name: selectedStudent.FIRST_NAME }) }}
								</button>
							</div>
						</div>
					</div>
					<div class="row school-information">
						<div class="col-md-5 school-logo" style="margin-top: 20px;">
							<img :src="districtImage.DISTRICT_LOGO_URL"
									 alt="Institute"
									 class="img-fluid">
						</div>
						<div class="col-md-7">
							<div v-for="school in selectedStudent.ENROLLMENT" :key="school.SCHOOL_ID">
								<h2>{{ school.SCHOOL_TITLE }}</h2>
								<p>
									<label>{{ $t('MAIN_CONTENT.commonContent.sideMenuGradeLabel') }}</label> {{ school.GRADE_LEVEL }} <br>
									<label>{{ $t('MAIN_CONTENT.ParentHomePage.schoolContactTitleCaseWithColon') }}</label> {{ school.SCHOOL_PHONE_NUMBER | phone }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-7 col-md-5">
				<fieldset class="goto">
					<div class="flex-container-wrap">
						<div v-for="( student, index ) in students" :key="index" class="select-student">
							<div class="text-center">
								<img :src="student.PHOTO_URL"
										 :alt="student.NAME" class="student-pic-dash"
										 style="width: 135px;cursor:pointer;"
										 @click="quickView(student)">
								<h3>{{ student.FIRST_NAME + " " + student.LAST_NAME }}</h3>
								<button @click="quickView(student)"
												class="btn btn-primary"
												:disabled="selectedStudent.STUDENT_RID === student.STUDENT_RID">
									<font-awesome-icon icon="search-plus" aria-hidden="true"></font-awesome-icon> {{ $t('MAIN_CONTENT.ParentHomePage.quickViewTitleCase') }}
								</button>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>
	</panel-basic>
</div>
</template>

<script>
	import PanelBasic from 'COMMONS/panels/PanelBasic.vue';

	import DistrictImage from '../api/DistrictImage';

	export default {
		name: 'ParentHomePage',
		props: {
			students: {
				type: Array,
				required: true
			}
		},
		data() {
			return {
				selectedStudent: {},
				districtImage: {}
			};
		},
		components: {
			PanelBasic
		},
		methods: {
			quickView(student) {
				this.$set(this, 'selectedStudent', student);
				window.scrollTo(0, 0);
			},
			setSelectedStudent() {
				this.$store.dispatch('updateSelectedStudentRID', this.selectedStudent.STUDENT_RID);
				this.$focusResetTab();
			},
			changeStudentData() {
				this.$store.dispatch('updateSelectedStudentRID', this.selectedStudent.STUDENT_RID);
				this.$router.push({ name: 'ChangeStudentData' });
			},
			getDistrictImage() {
				const self = this;
				
				const district = new DistrictImage({});

				const promise = district.get();

				promise.then(response => {
					self.$set(self, 'districtImage', district.getResponseData());
				});
			}
		},
		created() {
			this.$set(this, 'selectedStudent', this.students[0]);
			this.getDistrictImage();
		}
	}
</script>
